{
  "Announcements": "Announcements",
  "MarkAllAsRead": "Mark all as read",
  "NoLinkNotification": "No link available for this notification",
  "Notification": "Notifications",
  "ViewAll": "View all"
} 
